import ContentsExplorer from './ContentsExplorer';

export default ContentsExplorer;
